<script lang="ts" setup>
import {ArrowRightIcon} from '@heroicons/vue/20/solid'

const {collectionUri} = useI18nCollection();
const {getIndex, getAllButIndex} = usePage();
const pages = await queryCollection(collectionUri('aboutaermec')).all();
const index = getIndex(pages)!;
const entries = getAllButIndex(pages)!;
const imgUri = '/about-aermec/highlight.jpg';
</script>

<template>
  <section class="p-2">
    <div class="tablet:bg-brand-light tablet:rounded-3xl desktop:rounded-4xl tablet:py-18">
      <header class="page-container bg-brand-light mb-2 tablet:mb-12 tablet:bg-none rounded-img max-tablet:px-4 max-tablet:py-6 tablet:flex">
        <h2 class="section-title mb-6 tablet:w-1/2">
          {{ index.title }}
        </h2>
        <ContentRenderer :value="index" class="text-dark with-free-text tablet:w-1/2"/>
      </header>
      <div class="page-container max-tablet:px-0 pt-0">
        <div class="bg-secondary px-6 tablet:p-10 desktop:p-12 wide:p-14 py-8 rounded-img tablet:flex tablet:justify-between">
          <div class="tablet:w-3/8">
            <div class="sticky top-[110px]">
              <picture class="mb-8 block">
                <media-source
                        :dimensions="[
                          { width: 1920 },
                          { width: 1280 },
                          { width: 640 }
                        ]"
                        :uri="imgUri"
                        as="source"
                        format="webp"
                        sizes="100vw, (min-width: 768px) 33vw"
                />
                <media-source
                        :alt="index.title"
                        :dimensions="[
                          { width: 1920 },
                          { width: 1280 },
                          { width: 640 }
                        ]"
                        :uri="imgUri"
                        as="img"
                        class-name="w-full h-full object-cover rounded-img aspect-16/9"
                        format="jpg"
                        sizes="100vw, (min-width: 768px) 33vw"
                />
              </picture>
              <ButtonCta
                      v-if="index?.meta?.cta"
                      :cta="index.meta.cta"
                      class="hidden tablet:flex btn-border-green items-center"
              >
                <template #icon-end>
                  <ArrowRightIcon class="size-10 ms-2"/>
                </template>
              </ButtonCta>
            </div>
          </div>
          <div class="tablet:w-5/8 tablet:ps-16 desktop:ps-24 wide:ps-32">
            <ArticleHighlight
                    v-for="entry in entries"
                    :key="entry.path"
                    :title="entry.title"
                    class="border-b pb-4 border-light/25 laptop:flex mb-9 tablet:mb-6 laptop:mb-9"
                    header-class="laptop:w-1/2 pe-4"
                    summary-class="text-light/75 laptop:w-1/2 laptop:ps-4 tablet:text-sm"
                    title-class="text-light">
              <template #summary>
                <ContentRenderer :value="entry" class="with-free-text"/>
              </template>
            </ArticleHighlight>
            <ButtonCta
                    v-if="index?.meta?.cta"
                    :cta="index.meta.cta"
                    class="flex tablet:hidden btn-border-green items-center"
            >
              <template #icon-end>
                <ArrowRightIcon class="size-10 ms-2"/>
              </template>
            </ButtonCta>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>